function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "ic_error_warning");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "ic_error_warning",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M67.3201946,16.5431505 C66.9562203,15.9584989 66.46291,15.4651886 65.8782584,15.1012143 C63.7684232,13.7877385 60.9932812,14.4333153 59.6798054,16.5431505 L14.1848002,89.6217416 C13.740494,90.3354303 13.5049948,91.1593101 13.5049948,92 C13.5049948,94.4852814 15.5197134,96.5 18.0049948,96.5 L108.995005,96.5 C109.835695,96.5 110.659575,96.2645008 111.373264,95.8201946 C113.483099,94.5067188 114.128676,91.7315768 112.8152,89.6217416 L67.3201946,16.5431505 Z M76.6584481,10.72963 L122.153453,83.808221 C126.677648,91.0754313 124.453994,100.634254 117.186784,105.158448 C114.728523,106.688836 111.890715,107.5 108.995005,107.5 L18.0049948,107.5 C9.44458116,107.5 2.50499478,100.560414 2.50499478,92 C2.50499478,89.1042902 3.31615863,86.2664821 4.84654665,83.808221 L50.3415519,10.72963 C54.8657465,3.46241972 64.4245687,1.2387662 71.691779,5.76296081 C73.7055791,7.01665007 75.4047589,8.71582988 76.6584481,10.72963 Z",
  id: "Triangle",
  fill: "#D8D8D8",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.0230304,36 C57.0027982,36 56.9825706,36.000614 56.9623757,36.0018412 C56.4111078,36.0353399 55.9913729,36.5093869 56.0248716,37.0606548 L58.2124706,73.0606548 C58.2445406,73.5884105 58.6819002,74 59.2106294,74 L66.7894236,74 C67.3181529,74 67.7555125,73.5884105 67.7875824,73.0606548 L69.9751814,37.0606548 C69.9764086,37.0404598 69.9770226,37.0202322 69.9770226,37 C69.9770226,36.4477153 69.5293074,36 68.9770226,36 L57.0230304,36 Z",
  id: "Rectangle",
  stroke: "#7D7D7D",
  strokeWidth: 2,
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#7D7D7D",
  strokeWidth: 2,
  cx: 63.5,
  cy: 85.5,
  r: 5.5
})));

var SvgIcErrorWarning = function SvgIcErrorWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "127px",
    height: "110px",
    viewBox: "0 0 127 110",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcErrorWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_error_warning.a63f40ad.svg";
export { ForwardRef as ReactComponent };